import { IProductTasks } from "../../@types/Dashboard/IProductTasks";

type DispatchDetail = IProductTasks["dispatch"][number]["details"][number];

export function mapDispatchProducts(details: DispatchDetail[]) {
  return details.map(detail => ({
    mode: typeof detail.creep_feeding !== "boolean"
      ? "unknown"
      : detail.creep_feeding ? "creep" : "normal",
    product: detail.trade_name,
    classification: detail.supplement_classification,
    quantityKg: detail.quantity_kg,
  }));
}
